import { FileUp } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { MenuItem } from "@nexus/ui";
import { IMPORT_FROM_FILE_LABEL, workspaceImportPath } from "../workspaceImport";

/** "Import…", in the More actions menu beside Create dashboard/template. */
export function ImportFromFileItem({ from }: { from: "dashboards" | "templates" }) {
  const navigate = useNavigate();
  return (
    <MenuItem onSelect={() => navigate(workspaceImportPath(from))}>
      <FileUp className="size-3.5 text-muted" aria-hidden />
      {IMPORT_FROM_FILE_LABEL}
    </MenuItem>
  );
}
